import { browserHistory } from "../../shared/routes/browserHistory";
import {
  UPDATE_ACCOUNT,
  UPDATE_MESSAGE
} from "../../shared/constants/appConstants";
import apiRequest from "../../shared/network/apiRequest";
import localStorage from "../../shared/helpers/localStorage";

export default dispatch => () => {
  apiRequest
    .delete("/api/v1/tokens", dispatch)
    .then(function() {
      // clear local storage (except filter)
      localStorage.remove("token");
      localStorage.remove("landingPage");
      localStorage.remove("filter");

      // update account
      dispatch({
        type: UPDATE_ACCOUNT,
        payload: { account: { id: window.initialProps.accountId } }
      });
      // show message
      dispatch({
        type: UPDATE_MESSAGE,
        payload: {
          title: "message.logout.title",
          body: "message.logout.body"
        }
      });
      // redirect to login
      return browserHistory.push("/users/login");
    })
    .catch(function(error) {
      console.error("Error logout", error);
      dispatch({
        type: UPDATE_MESSAGE,
        payload: {
          title: "message.errorLogout.title",
          body: "message.errorLogout.body"
        }
      });
    });

  return {};
};
